document.addEventListener("DOMContentLoaded", () => {
  initWishlistIcons();
});

function initWishlistIcons() {
  updateAllWishlistIcons();
  updateHeaderWishlistIcon(); // [2] Header-Icon beim Laden direkt aktualisieren

  document.body.addEventListener("click", function (e) {
    const btn = e.target.closest(".wishlist-icon-wrapper");
    if (btn && btn.dataset.handle) {
      toggleWishlist(btn.dataset.handle);
    }
  });

  // [3] Beobachte DOM-Veränderungen (z. B. durch AJAX / Infinite Scroll)
  const observer = new MutationObserver(() => {
    updateAllWishlistIcons();
    updateHeaderWishlistIcon();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // [3] Sicherheits-Synchronisation (z. B. bei localStorage-Änderung in neuem Tab)
  setInterval(() => {
    updateAllWishlistIcons();
    updateHeaderWishlistIcon();
  }, 2000);
}

function toggleWishlist(handle) {
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  const index = wishlist.indexOf(handle);

  if (index > -1) {
    wishlist.splice(index, 1);
  } else {
    wishlist.push(handle);
  }

  localStorage.setItem("wishlist", JSON.stringify(wishlist));
  updateAllWishlistIcons();
  updateHeaderWishlistIcon(); // [2] Direkt nach Änderung auch das Header-Icon aktualisieren
}

function updateAllWishlistIcons() {
  document.querySelectorAll(".wishlist-icon-wrapper").forEach((el) => {
    const handle = el.getAttribute("data-handle");
    const svg = el.querySelector("svg");
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    if (!handle || !svg) return;

    if (wishlist.includes(handle)) {
      el.classList.add("active");
      svg.style.fill = "black";
      svg.style.stroke = "none";
    } else {
      el.classList.remove("active");
      svg.style.fill = "none";
      svg.style.stroke = "black";
    }
  });
}

function updateHeaderWishlistIcon() {
  const headerSvg = document.querySelector("[data-wishlist-header] svg");
  const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  if (!headerSvg) return;

  if (wishlist.length > 0) {
    headerSvg.style.fill = "black";
    headerSvg.style.stroke = "none";
  } else {
    headerSvg.style.fill = "none";
    headerSvg.style.stroke = "black";
  }
}

